/**
 * state of the shop
 */
const state = {
    BUILD_NUMBER: '0.0.1',
    COLLAPSE: true,
    SEPARETOR: process.env.NODE_ENV === 'development' ? 'T' : ' '
}

export default {
    state
}



// WEBPACK FOOTER //
// ./src/store/modules/constants.js